<mat-toolbar fxLayout="row" fxLayoutAlign="center center">
    <strong>Add New Location</strong>
</mat-toolbar>

<form [formGroup]="formGroup">
    <div fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-typeahead controlName="district" label="District" (searchTextChanged)="lookupDistricts($event)" [options]="locationObservable" telemetry="Edit-District-AddNewLocation-Inventory">
            </lgd-typeahead>

            <lgd-text controlName="code" label="Code" telemetry="Edit-Code-AddNewLocation-Inventory" style="margin: 0 1rem;">
            </lgd-text>

            <lgd-text controlName="description" label="Description" telemetry="Edit-Description-AddNewLocation-Inventory">
            </lgd-text>
        </div>
    </div>
</form>

<div fxLayout="row" fxLayoutAlign="end start">
    <command-bar [commands]="commands" telemetry="CmdBar-CommandKey-AddNewLocation-Inventory"></command-bar>
</div>

<mat-progress-bar *ngIf="saving" [fxShow]="saving" mode="indeterminate">
</mat-progress-bar>
